import { UserService } from '@app/user';
import { map, switchMap } from 'rxjs';
import { AdminItem } from '../modules/nav-item-admin/components/nav-item-admin-list/models';
import { NavMenuItem } from '../menu/models/nav-menu-item';

export const navItemsAccessFilter = (userService: UserService) =>
    switchMap((items: (AdminItem | NavMenuItem)[]) => userService.user$.pipe(map((user) => items.filter((item) => item.access(user)))));
